import useSWR  from 'swr';
import useREST from './useREST';

export default function useGET(path, axiosCfg, swrOpts) {
  const method = 'GET';
  const body = null;

  // null = don't send request
  const swrKey = path == null ? null : [path, method, body, axiosCfg];
  const fetcher = useREST();

  return useSWR(swrKey, fetcher, swrOpts);
}